module.exports = __webpack_public_path__ + "static/media/la.a2affa4a.svg";